import { useMemo } from 'react';
import { calculateAge } from 'helpers/utils';
import { BENEFICIARY_STATUS_SPONSORED } from './beneficiary-form/BeneficiaryForm';
import LoadingContainer from 'components/common/LoadingContainer';
import SponsorshipList from './sponsorship-content/SponsorshipList';
import { useBeneficiaries } from 'hooks/useBeneficiaries';

const SponsoredList = () => {
  const { beneficiaries, isLoading: loading } = useBeneficiaries();

  // Filter for sponsored beneficiaries
  const sponsoredBeneficiaries = useMemo(
    () =>
      beneficiaries?.filter(
        // grey statuses = left the programme: not listed here
        b =>
          b.status === BENEFICIARY_STATUS_SPONSORED &&
          !b.sponsorship_status?.is_hidden
      ) || [],
    [beneficiaries]
  );

  const beneficiariesData = useMemo(
    () =>
      sponsoredBeneficiaries.map(
        ({
          id,
          simple_id,
          first_name,
          middle_name,
          last_name,
          DOB,
          country,
          sponsorship_priority,
          duration,
          sponsorship_type,
          gender,
          image
        }) => ({
          id,
          simpleId: simple_id,
          name: `${first_name} ${middle_name ?? ''} ${last_name}`,
          age: calculateAge(DOB),
          location: country,
          sponsor: '-',
          renewal: ' -',
          priority: sponsorship_priority?.priority_type,
          duration,
          type: sponsorship_type?.type,
          gender,
          image
        })
      ) ?? [],
    [sponsoredBeneficiaries]
  );

  if (loading) return <LoadingContainer />;

  return (
    <SponsorshipList
      data={beneficiariesData}
      title="Sponsored"
      initialLayout="cardview"
    />
  );
};

export default SponsoredList;
